export const tableListaUzytkownikow = [
    {accessorKey: 'id', header: 'ID'},
    {
        accessorFn: (row) => [row.imie, row.nazwisko].filter(Boolean).join(' ').trim(),
        header: 'Imię i nazwisko',
    },
    {accessorKey: 'email', header: 'Email'},
    {accessorKey: 'profil_id', header: 'Profil ID'},
    {
        accessorKey: 'czy_powiazany_z_profilem',
        header: 'Powiązany z profilem',
    },
    {
        accessorKey: 'czy_powiazany_z_projektem',
        header: 'Powiązany z projektem',
    },
]
